import React from "react";
import { ExternalLink } from "pages/analystDirectory/parts/DownloadExcelLink";
import { _t } from "app/i18n/i18n";
import { useSelector } from "react-redux";
import { createBody } from "../data/generateBody";

export function CoverageDownloadLink() {
  const queryString = useSelector((state) => state.filter.qs);
  const body = createBody(queryString);
  body.size = 10000;
  body.from = 0;

  return (
    <ExternalLink
      url={`/research/japi/coverage/download?query=${encodeURIComponent(JSON.stringify(body))}`}
      label={_t("Download to Excel")}
      icon="fas fa-file-excel text-success"
      className="d-block text-right"
    />
  );
}
